module.exports = __webpack_public_path__ + "img/fstbgleaf.ecdd0287.png";